// Unified Icon component for consistent Lucide icon usage
import * as LucideIcons from 'lucide-react';

/**
 * Icon component wrapper for Lucide icons
 * @param {string} name - Icon name (PascalCase, e.g., 'FileText', 'Star')
 * @param {string} size - Size preset: 'sm' (16px), 'md' (20px), 'lg' (24px), 'xl' (32px)
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional props passed to the icon
 */
export default function Icon({ name, size = 'md', className = '', ...props }) {
    const sizeMap = {
        sm: 16,
        md: 20,
        lg: 24,
        xl: 32
    };

    const IconComponent = LucideIcons[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found in Lucide icons`);
        return null;
    }

    return (
        <IconComponent
            size={sizeMap[size] || sizeMap.md}
            className={`icon icon-${size} ${className}`.trim()}
            {...props}
        />
    );
}

// Named exports for common icons to enable tree-shaking
export {
    FileText,
    Star,
    Files,
    FileMinus,
    Users,
    Folder,
    FolderOpen,
    Tag,
    Settings,
    User,
    Plus,
    X,
    Pencil,
    Trash2,
    Search,
    SlidersHorizontal,
    Grid3X3,
    List,
    Menu,
    ArrowLeft,
    ChevronRight,
    ChevronDown,
    Inbox,
    Home,
    Upload,
    Archive,
    ExternalLink,
    Link,
    Copy,
    RefreshCw,
    Loader,
    Calendar,
    Globe,
    Check
} from 'lucide-react';
